module.exports = __webpack_public_path__ + "img/logo_dark.298d7538.svg";